import { getChainConnection } from './getChainConnection';

export const getConnectionsFromOtherItem = (itemPosition, allPositions) => {
    const itemPositionEntities = {};
    itemPosition.forEach((position) => {
        itemPositionEntities[position.guid] = position;
    });

    const chains = [];

    itemPosition.forEach((position) => {
        const nextPositions = position.connections
            .filter((connection) => {
                return position.guid === connection.from && !itemPositionEntities[connection.to];
            })
            .map((connection) => allPositions[connection.to]);

        if (nextPositions.length) {
            const chainsConnections = nextPositions.map((position) => [
                position,
                ...getChainConnection(position, allPositions),
            ]);

            chains.push(chainsConnections);
        }
    });
    return chains;
};
